'use client'

import { IProduct } from '@/entities/product/model/types'
import { useTranslations } from 'next-intl'
import React from 'react'
import { Flex, HStack, Text } from '@chakra-ui/react'

const Nutrients = ({ data }: { data: IProduct | null | undefined }) => {
  const t = useTranslations()

  if (!data) {
    return null
  }

  const nutrients = [
    { value: data.energy, label: t('energy_value'), measurment: t('kcal') },
    { value: data.proteins, label: t('proteins'), measurment: t('grams') },
    { value: data.fats, label: t('fats'), measurment: t('grams') },
    { value: data.carbohydrates, label: t('carbohydrates'), measurment: t('grams') },
  ]

  return <HStack gap={6} mt={{ base: 4, lg: 0 }} mb={4}>
    {nutrients
      .filter((nutrient) => nutrient.value && nutrient.value > 0)
      .map((nutrient, index) => (
        <Flex key={index} fontSize="sm" flexDir="column" gap={0}>
          <Text color="text.muted">{nutrient.label}</Text>
          <Text>{nutrient.value} {nutrient.measurment}</Text>
        </Flex>
      ))}
  </HStack>
}

export default Nutrients
